<template>
  <div id="content">
    <div class="col-md-10 col-md-offset-1">
      <div v-if="authenticated">
        <div>
          <div class="card">
            <div class="head">
              <canvas class="header-bg filtered" width="250" height="70" id="header-blur"></canvas>
            </div>
            <div class="foot">
              <div class="avatar">
                <img id="profile-picture" alt="Profile picture" :src="guest.picture" />
              </div>
              <div class="info">
                <p class="text-capitalize"> {{ fullName(guest) }} </p>
              </div>
            </div>
          </div>
        </div>
        <div id="alert-placeholder" class="extra-padding"></div>
        <div class="check-list panel panel-success">
          <div class="panel-heading">
            <span class="glyphicon glyphicon-ok"></span>
            {{ $t("uin.response") }}
          </div>
          <div class="[ form-group panel-body ]">
            <ul class="list-unstyled">
              <li v-for="(member, idx) in family" class="padding-bottom" :key="member.id">
                <input
                  type="checkbox"
                  :name="'checkbox-' + idx"
                  :id="'checkbox-' + idx"
                  v-model="family[idx].coming"
                  autocomplete="off"
                  />
                <div class="[ btn-group ]">
                  <label :for="'checkbox-' + idx" class="[ btn btn-primary c-white ]">
                    <span v-if="family[idx].coming" class="glyphicon glyphicon-ok"></span>
                    <span v-else class="inb"> </span>
                  </label>
                  <label :for="'checkbox-' + idx" class="[ btn btn-default active text-capitalize ]">
                    {{ fullName(member) }}
                  </label>
                </div>
              </li>
              <li class="extra-padding">
                <button
                  id="send-button"
                  class="btn btn-primary text-white"
                  @click="postResponses()"
                  disabled
                >
                  {{ $t("uin.save") }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="alert alert-success" role="alert">
          <h2> {{ $t("uin.authenticate") }} </h2>
          <div class="text-center">
            <span class="login-button" :class="textFont">
              <a
                href="#"
                role="button"
                class="btn btn-primary"
                @click="auth.login()"
              >
                {{ $t("app.login") }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import router from './../router'
import axios from 'axios'
const BASE_URL = 'https://shesaidyesto.me'

var multable = [
  1,57,41,21,203,34,97,73,227,91,149,62,105,45,39,137,241,107,3,173,39,71,65,238,219,101,187,87,81,151,141,133,249,117,221,209,197,187,177,169,5,153,73,139,133,127,243,233,223,107,103,99,191,23,177,171,165,159,77,149,9,139,135,131,253,245,119,231,224,109,211,103,25,195,189,23,45,175,171,83,81,79,155,151,147,9,141,137,67,131,129,251,123,30,235,115,113,221,217,53,13,51,50,49,193,189,185,91,179,175,43,169,83,163,5,79,155,19,75,147,145,143,35,69,17,67,33,65,255,251,247,243,239,59,29,229,113,111,219,27,213,105,207,51,201,199,49,193,191,47,93,183,181,179,11,87,43,85,167,165,163,161,159,157,155,77,19,75,37,73,145,143,141,35,138,137,135,67,33,131,129,255,63,250,247,61,121,239,237,117,29,229,227,225,111,55,109,216,213,211,209,207,205,203,201,199,197,195,193,48,190,47,93,185,183,181,179,178,176,175,173,171,85,21,167,165,41,163,161,5,79,157,78,154,153,19,75,149,74,147,73,144,143,71,141,140,139,137,17,135,134,133,66,131,65,129,1
]

var shgtable = [
  0,9,10,10,14,12,14,14,16,15,16,15,16,15,15,17,18,17,12,18,16,17,17,19,19,18,19,18,18,19,19,19,20,19,20,20,20,20,20,20,15,20,19,20,20,20,21,21,21,20,20,20,21,18,21,21,21,21,20,21,17,21,21,21,22,22,21,22,22,21,22,21,19,22,22,19,20,22,22,21,21,21,22,22,22,18,22,22,21,22,22,23,22,20,23,22,22,23,23,21,19,21,21,21,23,23,23,22,23,23,21,23,22,23,18,22,23,20,22,23,23,23,21,22,20,22,21,22,24,24,24,24,24,22,21,24,23,23,24,21,24,23,24,22,24,24,22,24,24,22,23,24,24,24,20,23,22,23,24,24,24,24,24,24,24,23,21,23,22,23,24,24,24,22,24,24,24,23,22,24,24,25,23,25,25,23,24,25,25,24,22,25,25,25,24,23,24,25,25,25,25,25,25,25,25,25,25,25,25,23,25,23,24,25,25,25,25,25,25,25,25,25,24,22,25,25,23,25,25,20,24,25,24,25,25,22,24,25,24,25,24,25,25,24,25,25,25,25,22,25,25,25,24,25,24,25,18
]

function stackBlurCanvasRGBA (canvas, topx, topy, width, height, radius) {
  if (isNaN(radius) || radius < 1) return
  radius |= 0

  var context = canvas.getContext('2d')
  var imageData = context.getImageData(topx, topy, width, height)
  var pixels = imageData.data

  var x, y, i, p, yp, yi, yw, rsum, gsum, bsum, asum,
    routsum, goutsum, boutsum, aoutsum,
    rinsum, ginsum, binsum, ainsum,
    pr, pg, pb, pa, rbs

  var div = radius + radius + 1
  var w4 = width << 2
  var widthMinus1 = width - 1
  var heightMinus1 = height - 1
  var radiusPlus1 = radius + 1
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2

  var stackStart = new BlurStack()
  var stack = stackStart
  for (i = 1; i < div; i++) {
    stack = stack.next = new BlurStack()
    if (i === radiusPlus1) var stackEnd = stack
  }
  stack.next = stackStart
  var stackIn = null
  var stackOut = null

  yw = yi = 0

  var mulsum = multable[radius]
  var shgsum = shgtable[radius]

  for (y = 0; y < height; y++) {
    rinsum = ginsum = binsum = ainsum = rsum = gsum = bsum = asum = 0

    routsum = radiusPlus1 * (pr = pixels[yi])
    goutsum = radiusPlus1 * (pg = pixels[yi + 1])
    boutsum = radiusPlus1 * (pb = pixels[yi + 2])
    aoutsum = radiusPlus1 * (pa = pixels[yi + 3])

    rsum += sumFactor * pr
    gsum += sumFactor * pg
    bsum += sumFactor * pb
    asum += sumFactor * pa

    stack = stackStart

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr
      stack.g = pg
      stack.b = pb
      stack.a = pa
      stack = stack.next
    }

    for (i = 1; i < radiusPlus1; i++) {
      p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2)
      rsum += (stack.r = (pr = pixels[p])) * (rbs = radiusPlus1 - i)
      gsum += (stack.g = (pg = pixels[p + 1])) * rbs
      bsum += (stack.b = (pb = pixels[p + 2])) * rbs
      asum += (stack.a = (pa = pixels[p + 3])) * rbs

      rinsum += pr
      ginsum += pg
      binsum += pb
      ainsum += pa

      stack = stack.next
    }

    stackIn = stackStart
    stackOut = stackEnd
    for (x = 0; x < width; x++) {
      pixels[yi + 3] = pa = (asum * mulsum) >> shgsum
      if (pa !== 0) {
        pa = 255 / pa
        pixels[yi] = ((rsum * mulsum) >> shgsum) * pa
        pixels[yi + 1] = ((gsum * mulsum) >> shgsum) * pa
        pixels[yi + 2] = ((bsum * mulsum) >> shgsum) * pa
      } else {
        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0
      }

      rsum -= routsum
      gsum -= goutsum
      bsum -= boutsum
      asum -= aoutsum

      routsum -= stackIn.r
      goutsum -= stackIn.g
      boutsum -= stackIn.b
      aoutsum -= stackIn.a

      p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2

      rinsum += (stackIn.r = pixels[p])
      ginsum += (stackIn.g = pixels[p + 1])
      binsum += (stackIn.b = pixels[p + 2])
      ainsum += (stackIn.a = pixels[p + 3])

      rsum += rinsum
      gsum += ginsum
      bsum += binsum
      asum += ainsum

      stackIn = stackIn.next

      routsum += (pr = stackOut.r)
      goutsum += (pg = stackOut.g)
      boutsum += (pb = stackOut.b)
      aoutsum += (pa = stackOut.a)

      rinsum -= pr
      ginsum -= pg
      binsum -= pb
      ainsum -= pa

      stackOut = stackOut.next

      yi += 4
    }
    yw += width
  }

  for (x = 0; x < width; x++) {
    ginsum = binsum = ainsum = rinsum = gsum = bsum = asum = rsum = 0

    yi = x << 2
    routsum = radiusPlus1 * (pr = pixels[yi])
    goutsum = radiusPlus1 * (pg = pixels[yi + 1])
    boutsum = radiusPlus1 * (pb = pixels[yi + 2])
    aoutsum = radiusPlus1 * (pa = pixels[yi + 3])

    rsum += sumFactor * pr
    gsum += sumFactor * pg
    bsum += sumFactor * pb
    asum += sumFactor * pa

    stack = stackStart

    for (i = 0; i < radiusPlus1; i++) {
      stack.r = pr
      stack.g = pg
      stack.b = pb
      stack.a = pa
      stack = stack.next
    }

    yp = width

    for (i = 1; i <= radius; i++) {
      yi = (yp + x) << 2

      rsum += (stack.r = (pr = pixels[yi])) * (rbs = radiusPlus1 - i)
      gsum += (stack.g = (pg = pixels[yi + 1])) * rbs
      bsum += (stack.b = (pb = pixels[yi + 2])) * rbs
      asum += (stack.a = (pa = pixels[yi + 3])) * rbs

      rinsum += pr
      ginsum += pg
      binsum += pb
      ainsum += pa

      stack = stack.next

      if (i < heightMinus1) {
        yp += width
      }
    }

    yi = x
    stackIn = stackStart
    stackOut = stackEnd
    for (y = 0; y < height; y++) {
      p = yi << 2
      pixels[p + 3] = pa = (asum * mulsum) >> shgsum
      if (pa > 0) {
        pa = 255 / pa
        pixels[p] = ((rsum * mulsum) >> shgsum) * pa
        pixels[p + 1] = ((gsum * mulsum) >> shgsum) * pa
        pixels[p + 2] = ((bsum * mulsum) >> shgsum) * pa
      } else {
        pixels[p] = pixels[p + 1] = pixels[p + 2] = 0
      }

      rsum -= routsum
      gsum -= goutsum
      bsum -= boutsum
      asum -= aoutsum

      routsum -= stackIn.r
      goutsum -= stackIn.g
      boutsum -= stackIn.b
      aoutsum -= stackIn.a

      p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2

      rsum += (rinsum += (stackIn.r = pixels[p]))
      gsum += (ginsum += (stackIn.g = pixels[p + 1]))
      bsum += (binsum += (stackIn.b = pixels[p + 2]))
      asum += (ainsum += (stackIn.a = pixels[p + 3]))

      stackIn = stackIn.next

      routsum += (pr = stackOut.r)
      goutsum += (pg = stackOut.g)
      boutsum += (pb = stackOut.b)
      aoutsum += (pa = stackOut.a)

      rinsum -= pr
      ginsum -= pg
      binsum -= pb
      ainsum -= pa

      stackOut = stackOut.next

      yi += width
    }
  }

  context.putImageData(imageData, topx, topy)
}

function BlurStack () {
  this.r = 0
  this.g = 0
  this.b = 0
  this.a = 0
  this.next = null
}

export default {
  name: 'Uin',
  props: ['auth', 'authenticated'],
  data () {
    return {
      err: null,
      guest: {},
      family: []
    }
  },
  created: function () {
    if (this.authenticated) {
      this.getGuest().then(function () {
        var BLUR_RADIUS = 10
        var sourceImage = document.getElementById('profile-picture')

        var drawBlur = function (canvas, image) {
          var w = canvas.width
          var h = canvas.height
          var canvasContext = canvas.getContext('2d')
          canvasContext.drawImage(image, 0, 0, w, h)
          stackBlurCanvasRGBA(canvas, 0, 0, w, h, BLUR_RADIUS)
        }

        var canvas = document.getElementById('header-blur')
        var image = new Image()
        image.src = sourceImage.getAttribute('src')

        image.onload = function () {
          drawBlur(canvas, image)
        }
      })

      var self = this
      this.getFamily().then(function () {
        var unwatch = self.$watch('family', function(oldValue, newValue) {
              document.getElementById('send-button').disabled = false
              unwatch()
            },
            {deep: true})
      })
    }
  },
  methods: {
    bootstrapAlert: function(message, status) {
      status = status || 'warning'
      $(`
        <div class="alert alert-${status} alert-dismissable">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true"> &times; </span>
          </button>
          <span>${message}</span>
        </div>`).appendTo("#alert-placeholder")
    },
    getGuest: function () {
      const url = `${BASE_URL}/api/guest?token=${localStorage.getItem('id_token')}`
      return axios.get(url, {headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Access-Control-Allow-Origin': '*'
      }})
        .then(response => {this.guest = response.data; return Promise.resolve()})
        .catch(err => {
          this.auth.logout()
        })
    },
    getFamily: function () {
      const url = `${BASE_URL}/api/family?token=${localStorage.getItem('id_token')}`
      let self = this
      return axios.get(url, {headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Access-Control-Allow-Origin': '*'
      }})
        .then(response => {
          self.$set(self, 'family', response.data)
          return Promise.resolve()
        })
        .catch(err => err || 'Unable to retrieve data')
    },
    postResponse: function (idx, response) {
      const url = `${BASE_URL}/api/response?token=${localStorage.getItem('id_token')}`
      return axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Access-Control-Allow-Origin': '*'
        },
        data: {
          coming: response,
          guest_id: this.family[idx].id
        }
      })
        .then(response => (console.log(response)))
        .catch(err => err || 'Unable to retrieve data')
    },
    postResponses: function () {
      const url = `${BASE_URL}/api/responses?token=${localStorage.getItem('id_token')}`
      var responses = []
      for (let member of this.family) {
        responses.push({guest_id: member.id, coming: member.coming})
      }
      return axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Access-Control-Allow-Origin': '*'
        },
        data: {
          responses: responses
        }
      })
        .then(response => ( this.bootstrapAlert( this.$t('uin.success'), 'success' )))
        .catch(err => ( this.bootstrapAlert( this.$t('uin.fail') ) ))
    },
    fullName: function (person) {
      if (this.$i18n.locale === 'fr') {
        return person.first_name_fr + ' ' + person.last_name_fr
      }
      return person.first_name + ' ' + person.last_name
    },
  },
  computed: {
    textFont: function () {
      return {
        'text-ge': this.$i18n.locale === 'ge',
        'text-fr': this.$i18n.locale === 'fr'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$blue: #0176A6;
$green: #08B387;
$green-dark: darken($green, 10);
$blue-dark: darken($blue, 15);
$blue-light: lighten($blue, 50);


.text-ge {
  font-family: 'Rayuela';
}

.text-fr {
  font-family: 'Moon Flower';
}

.login-button .btn {
  font-size: 2em;
  letter-spacing: 0.15em;
}

.content {
  color: $blue-dark;
}

.c-white {
  color: white !important;
}

.padding-bottom {
  padding-bottom: 10px;
}

.check-list {
  margin-top: 30px;
}

.form-group .btn, .panel-success > .panel-heading {
  font-size: 2rem;
  color: $blue-dark;
}

.form-group input[type="checkbox"] {
  display: none;
}

.form-group input[type="checkbox"] + .btn-group > label span {
  width: 20px;
}

.inb {
  display: inline-block;
}

.text-white {
  color: white !important;
}

.extra-padding {
  padding-top: 25px;
  font-size: 2rem;
}

/********* Profile ************/

.foot {
  padding-top: 100px;
}

.info {
  z-index: 100;
  font-size: 2.8em;
}

.filtered {
  // -webkit-filter: url(#f1);
  // filter: url(#f1);
  // filter: blur(3px);
}

.src-image {
	display: none;
}

.card {
	overflow: hidden;
	position: relative;
	border: 1px solid #CCC;
	border-radius: 8px;
	text-align: center;
	padding: 0;
	background-color: white; // $blue-light; // #284c79;
	color: $blue-dark; // rgb(136, 172, 217);
  height: 350px;
}

.card .header-bg {
	/* This stretches the canvas across the entire hero unit */
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 200px;
	border-bottom: 1px #FFF solid;
	/* This positions the canvas under the text */
	z-index: 0;
}

.card .avatar {
	margin-top: 15px;
	z-index: 100;
}

.card .avatar img {
	position: relative;
	width: 150px;
	height: 150px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	border: 5px solid rgba(0, 0, 30, 0.8);
}

</style>



// WEBPACK FOOTER //
// src/components/Uin.vue